import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["hourlyRate", "monthlyAmount"]

  connect() {
    this.toggle()
  }

  toggle() {
    const selectedType = this.element.querySelector("select").value

    this.hourlyRateTarget.style.display = selectedType === "hourly" ? "block" : "none"
    this.monthlyAmountTarget.style.display = selectedType === "monthly" ? "block" : "none"
  }
}
